import { ContactUsPage, HelpPage, PrivacyPage, TermsPage } from "./vyntezbuddy/LegalPages";
import { Navigate, createBrowserRouter } from "react-router-dom";

import AuthLoginScreen from "./pre-login-components/login/login";
import CabBookingScreen from "./vyntezbuddy/CabBookingScreen";
import ConsumerDashboardScreen from "./post-login-components/dashboard/dashboard";
import HomeScreen from "./post-login-components/home/home";
import PostLoginLayout from "./post-login-components/layout/PostLoginLayout";
import ProviderRegisterPlaceholder from "./vyntezbuddy/ProviderRegisterPlaceholder";
import React from "react";
import ServiceDashboard from "./post-login-components/addServices/ServiceDashboard";
import ServiceCategoryDetailsScreen from "./vyntezbuddy/ServiceCategoryDetailsScreen";
import ServiceDetailScreen from "./vyntezbuddy/ServiceDetailScreen";
import UserAddresses from "./post-login-components/user-data/addresses/UserAddresses";
import UserProfile from "./post-login-components/user-data/user-profile/userprofile";
import ServiceProviderProfile from "./post-login-components/provider-data/service-provider-profile/serviceProvider";

const getDashboardPath = () => {
  const activeRole = sessionStorage.getItem("vbActiveRole") || "consumer";
  return activeRole === "provider" ? "/provider-dashboard" : "/consumer-dashboard";
};

const PublicHomeRoute = () => {
  const token = sessionStorage.getItem("token");
  if (token) {
    return <Navigate to={getDashboardPath()} replace />;
  }

  return <HomeScreen />;
};

const DashboardRedirect = () => {
  return <Navigate to={getDashboardPath()} replace />;
};

const NotFoundRedirect = () => {
  const token = sessionStorage.getItem("token");
  return <Navigate to={token ? getDashboardPath() : "/"} replace />;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <PublicHomeRoute />
  },
  {
    path: "/home",
    element: <PublicHomeRoute />
  },
  {
    path: "/login",
    element: <AuthLoginScreen />
  },
  {
    path: "/services/:categorySlug",
    element: <ServiceCategoryDetailsScreen />
  },
  {
    path: "/services/:categorySlug/:serviceSlug",
    element: <ServiceDetailScreen />
  },
  {
    path: "/cab-booking",
    element: <CabBookingScreen />
  },
  {
    path: "/provider-register",
    element: <ProviderRegisterPlaceholder />
  },
  {
    path: "/terms",
    element: <TermsPage />
  },
  {
    path: "/privacy",
    element: <PrivacyPage />
  },
  {
    path: "/help",
    element: <HelpPage />
  },
  {
    path: "/contact-us",
    element: <ContactUsPage />
  },
  {
    element: <PostLoginLayout />,
    children: [
      {
        path: "/consumer-dashboard",
        element: <ConsumerDashboardScreen />
      },
      {
        path: "/dashboard",
        element: <DashboardRedirect />
      },
      {
        path: "/provider-dashboard",
        element: <ServiceDashboard />
      },
      {
        path: "/home/user-profile",
        element: <UserProfile />
      },
      {
        path: "/home/user-addresses",
        element: <UserAddresses />
      },
      {
        path: "/home/provider-services",
        element: <ServiceProviderProfile />
      }
    ]
  },
  {
    path: "*",
    element: <NotFoundRedirect />
  }
]);

export default router;
